import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function UsersIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M9.39999 8C11.0568 8 12.4 6.65685 12.4 5C12.4 3.34315 11.0568 2 9.39999 2C7.74314 2 6.39999 3.34315 6.39999 5C6.39999 6.65685 7.74314 8 9.39999 8Z"
        fill="currentColor"
      />
      <path
        d="M9.39999 13.9999C12.051 13.9999 14.2 12.7911 14.2 11.2999C14.2 9.80877 12.051 8.59994 9.39999 8.59994C6.74902 8.59994 4.59999 9.80877 4.59999 11.2999C4.59999 12.7911 6.74902 13.9999 9.39999 13.9999Z"
        fill="currentColor"
      />
      <path
        d="M6.06667 3.02148C6.06667 2.83058 5.92423 2.66667 5.73333 2.66667C4.26057 2.66667 3.06667 3.86057 3.06667 5.33333C3.06667 6.80609 4.26057 8 5.73333 8C5.92423 8 6.06667 7.83609 6.06667 7.64518V7.30222C6.06667 7.12881 5.90674 7 5.73333 7C4.81286 7 4.06667 6.25381 4.06667 5.33333C4.06667 4.41286 4.81286 3.66667 5.73333 3.66667C5.90674 3.66667 6.06667 3.53786 6.06667 3.36445V3.02148Z"
        fill="currentColor"
      />
      <path
        d="M3.78543 9.01582C4.09557 8.91221 4.4 9.15625 4.4 9.48324C4.4 9.71433 4.2436 9.91365 4.0257 9.99063C3.82324 10.0622 3.63927 10.143 3.47664 10.2306C2.82405 10.582 2.73333 10.8998 2.73333 11C2.73333 11.1002 2.82405 11.4181 3.47664 11.7695C3.63927 11.857 3.82324 11.9379 4.0257 12.0094C4.2436 12.0864 4.4 12.2857 4.4 12.5168C4.4 12.8438 4.09557 13.0878 3.78543 12.9842C2.55364 12.5727 1.73333 11.838 1.73333 11C1.73333 10.1621 2.55364 9.4273 3.78543 9.01582Z"
        fill="currentColor"
      />
    </svg>
  )
}
